﻿import { EmailAddressField } from '../../enums/index';
import { ContactEntityType } from '../../enums/index';
import { CenterType } from '../../enums/index';

export interface IEmailSendeeContract {
    id: number;
    emailAddressField: EmailAddressField;
    contactEntityType: ContactEntityType;
    centerType: CenterType;
    contactPositionId: number;
}
